export interface DashboardBadges {
  'all'?: number;
  'completed'?: number;
  'inProgress'?: number;
  'req4change'?: number;
  'unallocated'?: number;
  'cancelled'?: number;
}

export const dashboardTabs = {
  all: 'All',
  completed: 'Completed',
  inProgress: 'In progress',
  req4change: 'Requested for change',
  unallocated: 'Unallocated',
  cancelled: 'Cancelled',
} as const;

export const dispatchJobsTabs = {
  unallocated: 'Unallocated',
  preallocated: 'Pre-Allocated',
  allocated: 'Allocated',
} as const;

export const notificationsTabs = {
  all: 'All',
  tickets: 'Tickets',
  jobs: 'Jobs',
  reports: 'Reports',
} as const;

export const helpcenterTabs = {
  browse: 'Browse help library',
  contact: 'Contact support',
} as const;
